<template>
  <transition name="fade">
    <div class="success-popup" v-if="open">
      <div class="mask" @click="close"></div>

      <Block type="serviceSuccessPopup" class="success-popup-main">
        <!-- <a href="javascript:;" @click="close" class="success-popup-main-close"></a> -->
        <Button
          type="closeBtn"
          class="success-popup-main-close"
          :class="$platformClass"
          @click="close"
        ></Button>
        <Icon
          type="storesuccess"
          class="checked"
          :class="$platformClass"
        ></Icon>
        <p class="success-popup-main-tips" :class="$platformClass">{{ msg }}</p>
        <!-- <a :href="deepLink" class="success-popup-main-back text" @click="goGame" v-show="!isWeb">
          <i class="helmet"></i>
          {{letters._goGame}}
        </a> -->
        <Button
          :href="deepLink"
          tagName="a"
          type="shortWidth"
          v-show="!isWeb"
          class="success-popup-main-back text"
        >
          <Icon type="helmet"></Icon>
          <Icon type="resultBackBtnLeft"></Icon>
          <Icon type="resultBackBtnRight"></Icon>
          {{ letters._goGame }}
        </Button>
        <Button
          type="showServiceList"
          @click="goWorkList"
          class="success-popup-main-history text"
        >
          <!-- <i class="folder"></i> -->
          <Icon type="folder"></Icon>
          <Icon type="resultHistoryBtnLeft"></Icon>
          <Icon type="resultHistoryBtnRight"></Icon>
          {{ letters._history }}
        </Button>
      </Block>
    </div>
  </transition>
</template>
<script>
import getLetters from '../../mixins/getLetters.js';
import globalConfig from '../../utiles/globalConfig.js';
import { OPEN_PAGE_NAME } from '../../store/support/event-type';
import bridge from '@utiles/bridge';
const isInSdk = bridge.runInsdk();

export default {
  name: 'success-popup',
  computed: {},
  mixins: [getLetters],
  data: () => {
    return {
      deepLink: '',
      // 是否处于web端，如果是的话要隐藏返回游戏按钮
      // 如果在webview里面的话也隐藏返回按钮
      isWeb: globalConfig.getHrefParamUndecode('web') === '1' || isInSdk
    };
  },
  created: function () {
    let sdkToken = globalConfig.getHrefParam('sdkToken');
    this.deepLink = `javascript:window.open('${sdkToken}://')`;
  },
  methods: {
    close: function () {
      this.$emit('toggle');
    },
    goWorkList: function () {
      let query = this.$route.query;
      this.$store.commit(OPEN_PAGE_NAME, 'mylist');
      this.$router.push({ name: 'mylist', query });
    }
  },
  props: ['open', 'msg']
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.checked {
  @include size(190, 190);
  display: inline-block;
  @include bgPng('checked-icon');
  // position: absolute;
  // left: 144px;
  // top: 52px;
  margin: 0 auto;
  margin-top: 52px;
}
.success-popup {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  &-main {
    @include size(513, 660);
    border: solid 14px #fff;
    @include bgC(#f3f3f3);
    @extend %abs-center;
    z-index: 10;
    &-close {
      @extend %popup-close;
      position: absolute;
      right: 9px;
      top: 9px;
    }
    &-tips {
      width: 100%;
      padding: 0 34px;
      font-size: 24px;
      color: #414141;
      text-align: center;
      word-break: break-all;
      position: absolute;
      top: 271px;
    }
    &-back {
      @include size(300, 74);
      position: absolute;
      left: 50%;
      margin-left: -150px;
      // top: 413px;
      top: 425px;
      @include bgC(#9588e4);
      color: #fff;
      line-height: 74px;
      text-align: center;
      display: block;
    }
    &-history {
      @include size(300, 74);
      position: absolute;
      left: 50%;
      margin-left: -150px;
      top: 517px;
      @include bgC(#5fd193);
      color: #fff;
      line-height: 74px;
    }
  }
}
@media screen and (orientation: landscape) and (min-width: 1000px) {
  .success-popup {
    &-main {
      transform: translate(-50%, -50%) scale(0.7);
    }
  }
}
</style>
